import { ROUTE_TYPE } from './constants';

import React from 'react';

// Icons import
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import SettingsIcon from '@material-ui/icons/Settings';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import SportsEsportsIcon from '@material-ui/icons/SportsEsports';
import DashboardFinal from '../pages/Dashboard/DashboardFinal';
import Login from '../pages/Login/Login';
import ManageUsersTable from '../components/settings/ManageUsers/ManageUsersTable';
import Customer from '../components/customer/Customer';
import { ReceiptLong } from '@mui/icons-material';
import ManageMachine from '../components/settings/ManageMachine/ManageMachine';
import ManageGame from '../components/settings/ManageGame/ManageGame';
import MasterReading from '../components/reading/masterReading/MasterReading';
import TicketOut from '../components/ticketOut/TicketOut';
import Transaction from '../components/transaction/Transaction';
import ClockInOut from '../components/clockinout/ClockInOut';
import EmployeeSession from '../components/employeeSession/EmployeeSession';
import Raffle from '../components/raffle/Raffle';
import DevicesIcon from '@mui/icons-material/Devices';
import PointsWatching from '../components/pointsWatching/PointsWatching';
import ManageBonus from '../components/settings/ManageBonus/ManageBonus';
import Bonus from '../components/bonus/Bonus';
import StarIcon from '@mui/icons-material/Star';
import MasterRecordForm from '../components/reading/addReading/MasterRecordForm';
import PostAddIcon from '@mui/icons-material/PostAdd';
import CategoryIcon from '@mui/icons-material/Category';
import AssignGameToMachine from '../components/settings/assignGameToMachine/AssignGameToMachine';
import SetupMachines from '../components/settings/SetupMachines/SetupMachines';
import TransactionIcon from '../components/assets/transaction.png';
import RaffleIcon from '../components/assets/raffle.png';
import ShiftReportIcon from '../components/assets/shift-report.png';
import ManageRule from '../components/settings/ManageRule/ManageRule';
import TuneIcon from '@material-ui/icons/Tune';
import MaintenancePermit from '../components/settings/MaintenancePermit/MaintenancePermit';
import BuildIconBase from '@material-ui/icons/Build';
import MachinePicture from '../components/reading/machinePicture/MachinePicture';
import Note from '../components/note/Note';
import ReportView from '../components/accounting/weeklyReport/ReportView';
import BonusIcon from '../components/assets/bonus.png';
import TicketIcon from '../components/assets/ticket-out.png';
import CustomerIcon from '../components/assets/customer.png';
import ClockInIcon from '../components/assets/clock-in.png';
import PointWatchIcon from '../components/assets/point-watch.png';
import DashboardIcon from '@material-ui/icons/Dashboard';
import AssessmentIcon from '@mui/icons-material/Assessment';
import NoteIcon from '../components/assets/note.png';
import MachinePictureIcon from '../components/assets/machine-picture.png';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import CalculateIcon from '@mui/icons-material/Calculate';
import VisibilityIcon from '@mui/icons-material/Visibility';
import StoreIcon from '@material-ui/icons/Store';
import ManageCompanyTable from '../components/settings/ManageCompany/ManageCompanyTable';
import CustomerLoanReport from '../components/accounting/customerLoanReport/CustomerLoanReport';
import EmployeeShortReport from '../components/accounting/employeeShortReport/EmployeeShortReport';
import ZelleReport from '../components/accounting/zelleReport/ZelleReport';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import UserProfile from '../components/profile/UserProfile';
import CustomerClaimPage from '../components/customer/CustomerClaimPage';
import NfcGatePage from '../components/security/NfcGatePage';
import RegistrationRequiredPage from '../components/security/RegistrationRequiredPage';
import PrivacyPolicy from './PrivacyPolicy';
import TermsAndConditions from './TermsAndConditions';
import SmsOptIn from './SmsOptIn';
import SecurityDashboard from '../components/security/SecurityDashboard';
import SessionComplete from '../components/security/SessionComplete';
import ConsentPage from '../components/verification/ConsentPage';
import NuVeBoost from '../components/boost/NuVeBoost';
import LandingPage from '../components/landing/LandingPage';
import GetStarted from '../components/landing/GetStarted';
import BoostIcon from '../components/assets/boost.png';

/**
 * {
 *  id: Route id,
 *  name: Name of route,
 *  path: location,
 *  component: React component,
 *  icon: icon name for sidebar,
 *  sidebar: show on sidebar link or no, true or false
 * }
 */

// Wrapper that forces a smaller icon size in the sidebar — MenuItem
// renders all icons with fontSize='large', but the Maintenance Permit
// wrench reads visually heavier than its neighbours at that size.
const BuildIcon = (props) => (
  <BuildIconBase
    {...props}
    fontSize="small"
    style={{ fontSize: 28, ...(props.style || {}) }}
  />
);

const TransactionImgIcon = () => (
  <img
    src={TransactionIcon}
    alt="Transaction"
    style={{
      width: '48px',
      height: '48px',
      marginRight: '-6px',
      marginLeft: '-6px',
    }}
  />
);
const RaffleImgIcon = () => (
  <img
    src={RaffleIcon}
    alt="Raffle"
    style={{
      width: '48px',
      height: '32px',
      marginRight: '-6px',
      marginLeft: '-6px',
    }}
  />
);
const ShiftReportImgIcon = () => (
  <img
    src={ShiftReportIcon}
    alt="Shift Report"
    style={{
      width: '48px',
      height: '48px',
      marginRight: '-6px',
      marginLeft: '-6px',
    }}
  />
);
const PointWatchImgIcon = () => (
  <img
    src={PointWatchIcon}
    alt="Point Watching"
    style={{
      width: '48px',
      height: '48px',
      marginRight: '-6px',
      marginLeft: '-6px',
    }}
  />
);
const ClockInImgIcon = () => (
  <img
    src={ClockInIcon}
    alt="Clock In/Out"
    style={{
      width: '48px',
      height: '48px',
      marginRight: '-6px',
      marginLeft: '-6px',
    }}
  />
);
const TicketImgIcon = () => (
  <img
    src={TicketIcon}
    alt="Ticket Out"
    style={{
      width: '48px',
      height: '48px',
      marginRight: '-6px',
      marginLeft: '-6px',
    }}
  />
);
const CustomerImgIcon = () => (
  <img
    src={CustomerIcon}
    alt="Customers"
    style={{
      width: '48px',
      height: '48px',
      marginRight: '-6px',
      marginLeft: '-6px',
    }}
  />
);
const BoostImgIcon = () => (
  <img
    src={BoostIcon}
    alt="Boost"
    style={{
      width: '48px',
      height: '48px',
      marginRight: '-6px',
      marginLeft: '-6px',
    }}
  />
);
const BonusImgIcon = () => (
  <img
    src={BonusIcon}
    alt="Bonus"
    style={{
      width: '48px',
      height: '48px',
      marginRight: '-6px',
      marginLeft: '-6px',
    }}
  />
);
const NoteImgIcon = () => (
  <img
    src={NoteIcon}
    alt="Note"
    style={{
      width: '48px',
      height: '48px',
      marginRight: '-6px',
      marginLeft: '-6px',
    }}
  />
);
const MachinePictureImgIcon = () => (
  <img
    src={MachinePictureIcon}
    alt="Machine-pic"
    style={{
      width: '48px',
      height: '48px',
      marginRight: '-6px',
      marginLeft: '-6px',
    }}
  />
);

export const routes = [
  {
    type: ROUTE_TYPE.MENU_ITEM,
    id: 'landing',
    label: 'Landing',
    icon: VpnKeyIcon,
    path: '/landing',
    component: LandingPage,
    sidebar: false,
  },
  {
    type: ROUTE_TYPE.MENU_ITEM,
    id: 'get-started',
    label: 'Get Started',
    icon: VpnKeyIcon,
    path: '/get-started',
    component: GetStarted,
    sidebar: false,
  },
  {
    type: ROUTE_TYPE.MENU_ITEM,
    id: 'login',
    label: 'Login',
    icon: VpnKeyIcon,
    path: '/login',
    component: Login,
    sidebar: false,
  },
  {
    type: ROUTE_TYPE.MENU_ITEM,
    id: 'profile',
    label: 'Profile',
    icon: AccountBoxIcon,
    path: '/profile',
    component: UserProfile,
    sidebar: false,
  },
  {
    type: ROUTE_TYPE.MENU_ITEM,
    id: 'claim',
    label: 'Claim',
    icon: CustomerImgIcon,
    path: '/claim',
    component: CustomerClaimPage,
    sidebar: false,
  },
  {
    type: ROUTE_TYPE.MENU_ITEM,
    id: 'gate-check-in',
    label: 'Gate Check In',
    icon: CustomerImgIcon,
    path: '/gate-check-in',
    component: NfcGatePage,
    sidebar: false,
  },
  {
    type: ROUTE_TYPE.MENU_ITEM,
    id: '404',
    label: '404 | Page not found',
    icon: CustomerImgIcon,
    path: '/404',
    component: RegistrationRequiredPage,
    sidebar: false,
  },
  {
    type: ROUTE_TYPE.MENU_ITEM,
    id: 'privacy-policy',
    label: 'Privacy Policy',
    icon: CustomerImgIcon,
    path: '/privacy-policy',
    component: PrivacyPolicy,
    sidebar: false,
  },
  {
    type: ROUTE_TYPE.MENU_ITEM,
    id: 'terms-and-conditions',
    label: 'Terms & Conditions',
    icon: CustomerImgIcon,
    path: '/terms-and-conditions',
    component: TermsAndConditions,
    sidebar: false,
  },
  {
    type: ROUTE_TYPE.MENU_ITEM,
    id: 'sms-opt-in',
    label: 'SMS Opt-In Disclosure',
    icon: CustomerImgIcon,
    path: '/sms-opt-in',
    component: SmsOptIn,
    sidebar: false,
  },
  {
    type: ROUTE_TYPE.MENU_ITEM,
    id: 'security',
    label: 'Security',
    icon: CustomerImgIcon,
    path: '/security',
    component: SecurityDashboard,
    sidebar: false,
  },
  {
    type: ROUTE_TYPE.MENU_ITEM,
    id: 'session-complete',
    label: 'Session Complete',
    icon: CustomerImgIcon,
    path: '/session-complete',
    component: SessionComplete,
    sidebar: false,
  },
  {
    // NDS Phone Verification — public consent page opened from the SMS link
    // on the customer's own phone (Flow 2). Dynamic token segment.
    type: ROUTE_TYPE.MENU_ITEM,
    id: 'verify-consent',
    label: 'Activate Membership',
    icon: CustomerImgIcon,
    path: '/v/:token',
    component: ConsentPage,
    sidebar: false,
  },
];
export const protectedRoutes = [
  {
    type: ROUTE_TYPE.MENU_ITEM,
    id: 'dashboard',
    label: 'Dashboard',
    icon: DashboardIcon,
    path: '/dashboard',
    component: DashboardFinal,
    sidebar: true,
  },
  {
    type: ROUTE_TYPE.DIVIDER,
    sidebar: true,
  },
  {
    type: ROUTE_TYPE.MENU_ITEM,
    id: 'customers',
    label: 'Customer',
    icon: CustomerImgIcon,
    path: '/customer',
    component: Customer,
    sidebar: true,
  },
  {
    type: ROUTE_TYPE.DIVIDER,
    sidebar: true,
  },
  {
    type: ROUTE_TYPE.MENU_ITEM,
    id: 'transaction',
    label: 'Transaction',
    icon: TransactionImgIcon,
    sidebar: true,
    path: '/transaction',
    component: Transaction,
  },
  {
    type: ROUTE_TYPE.DIVIDER,
    sidebar: true,
  },
  {
    type: ROUTE_TYPE.MENU_ITEM,
    id: 'ticket-out',
    label: 'Ticket Out',
    icon: TicketImgIcon,
    sidebar: true,
    path: '/ticket-out',
    component: TicketOut,
  },
  {
    type: ROUTE_TYPE.DIVIDER,
    sidebar: true,
  },
  {
    type: ROUTE_TYPE.MENU_ITEM,
    id: 'bonus',
    label: 'Bonus',
    icon: BonusImgIcon,
    sidebar: true,
    path: '/bonus',
    component: Bonus,
  },
  {
    type: ROUTE_TYPE.DIVIDER,
    sidebar: true,
  },
  {
    type: ROUTE_TYPE.MENU_ITEM,
    id: 'raffle',
    label: 'Raffle',
    icon: RaffleImgIcon,
    path: '/raffle',
    component: Raffle,
    sidebar: true,
  },
  {
    type: ROUTE_TYPE.DIVIDER,
    sidebar: true,
  },
  {
    type: ROUTE_TYPE.MENU_ITEM,
    id: 'note',
    label: 'Note',
    icon: NoteImgIcon,
    path: '/note',
    component: Note,
    sidebar: true,
  },
  {
    type: ROUTE_TYPE.DIVIDER,
    sidebar: true,
  },
  {
    type: ROUTE_TYPE.MENU_ITEM,
    id: 'boost',
    label: 'NuVe Boost',
    icon: BoostImgIcon,
    path: '/boost',
    component: NuVeBoost,
    sidebar: true,
  },
  {
    type: ROUTE_TYPE.DIVIDER,
    sidebar: true,
  },
  {
    type: ROUTE_TYPE.MENU_ITEM,
    id: 'check-in-out',
    label: 'Check In/Out',
    icon: ClockInImgIcon,
    path: '/check-in-out',
    component: ClockInOut,
    sidebar: true,
  },
  {
    type: ROUTE_TYPE.DIVIDER,
    sidebar: true,
  },
  {
    type: ROUTE_TYPE.SUB_MENU,
    id: 'operation-monitor',
    label: 'Operations Monitor',
    icon: VisibilityIcon,
    sidebar: true,
    requiresAnyOf: ['point-watching', 'employee-session'],
    submenuItems: [
      {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'point-watching',
        label: 'Point Watching',
        icon: PointWatchImgIcon,
        sidebar: true,
        path: '/point-watching',
        component: PointsWatching,
      },
      {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'employee-session',
        label: 'Employee Session',
        icon: ShiftReportImgIcon,
        path: '/employee-session',
        component: EmployeeSession,
        sidebar: true,
      },
    ],
  },
  {
    type: ROUTE_TYPE.DIVIDER,
    sidebar: true,
  },
  {
    type: ROUTE_TYPE.SUB_MENU,
    id: 'reading',
    label: 'Reading',
    icon: CalculateIcon,
    sidebar: true,
    submenuItems: [
      {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'machine-picture',
        label: 'Machine Reading Pictures',
        icon: MachinePictureImgIcon,
        path: '/machine-picture',
        component: MachinePicture,
        sidebar: true,
      },
      {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'add-machine-reading',
        label: 'Start New Reading Session',
        icon: PostAddIcon,
        sidebar: true,
        path: '/add-machine-reading',
        component: MasterRecordForm,
      },
      {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'master-reading',
        label: 'Reading Sessions Record',
        icon: ReceiptLong,
        sidebar: true,
        path: '/master-reading',
        component: MasterReading,
      },
    ],
  },
  {
    type: ROUTE_TYPE.SUB_MENU,
    id: 'accounting',
    label: 'Accounting',
    icon: CalculateIcon,
    sidebar: true,
    submenuItems: [
      {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'report',
        label: 'Weekly Report',
        icon: AssessmentIcon,
        path: '/report',
        component: ReportView,
        sidebar: true,
      },
      {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'customer-loan-report',
        label: 'Customer Loan Report',
        icon: LocalAtmIcon,
        sidebar: true,
        path: '/accounting/customer-loan-report',
        component: CustomerLoanReport,
      },
      {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'employee-short-report',
        label: 'Employee Short Report',
        icon: LocalAtmIcon,
        sidebar: true,
        path: '/accounting/employee-short-report',
        component: EmployeeShortReport,
      },
      {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'zelle-report',
        label: 'Zelle Report',
        icon: LocalAtmIcon,
        sidebar: true,
        path: '/accounting/zelle-report',
        component: ZelleReport,
      },
    ],
  },
  {
    type: ROUTE_TYPE.SUB_MENU,
    id: 'settings',
    label: 'Settings',
    icon: SettingsIcon,
    sidebar: true,
    submenuItems: [
      {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'company',
        label: 'Manage Company',
        icon: StoreIcon,
        sidebar: true,
        path: '/settings/manage-company',
        component: ManageCompanyTable,
      },
      {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'manage-rule',
        label: 'Rules & Access',
        icon: TuneIcon,
        path: '/settings/rules',
        component: ManageRule,
        sidebar: true,
      },
      {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'setup-machines',
        label: 'Setup Machines',
        icon: DevicesIcon,
        sidebar: true,
        path: '/settings/setup-machines',
        component: SetupMachines,
        requiresAnyOf: ['machine', 'game', 'assign-machine'],
      },
      {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'machine',
        label: 'Machines',
        icon: DevicesIcon,
        sidebar: false,
        path: '/settings/machine',
        component: ManageMachine,
      },

      {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'game',
        label: 'Games',
        icon: SportsEsportsIcon,
        sidebar: false,
        path: '/settings/games',
        component: ManageGame,
      },

      {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'assign-machine',
        label: 'Assign Machine',
        icon: CategoryIcon,
        sidebar: false,
        path: '/settings/assign-machine',
        component: AssignGameToMachine,
      },

      {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'manage-bonus',
        label: 'Manage Bonus',
        icon: StarIcon,
        sidebar: true,
        path: '/settings/manage-bonus',
        component: ManageBonus,
      },
      {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'manage-users',
        label: 'Manage Employees',
        icon: SupervisorAccountIcon,
        sidebar: true,
        path: '/settings/manage-users',
        component: ManageUsersTable,
      },
      {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'maintenance-permit',
        label: 'Maintenance Permit',
        icon: BuildIcon,
        sidebar: true,
        path: '/settings/maintenance-permit',
        component: MaintenancePermit,
      },
    ],
  },
];

export const getSubmenuRoutes = (submenuItems) => {
  let submenuRoutes = [];
  submenuItems.map((item) => {
    if (item.type === ROUTE_TYPE.MENU_ITEM) {
      submenuRoutes = [...submenuRoutes, item];
    } else if (item.type === ROUTE_TYPE.SUB_MENU) {
      submenuRoutes = [
        ...submenuRoutes,
        ...getSubmenuRoutes(item.submenuItems),
      ];
    }

    return item;
  });

  return submenuRoutes;
};

export const getRoutes = () => {
  return [...getSubmenuRoutes(protectedRoutes)];
};
